var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptDisscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.52 1.33334H5.48C2.96 1.33334 2.33333 2.00668 2.33333 4.69334V12.2C2.33333 13.9733 3.30666 14.3933 4.48666 13.1267L4.49333 13.12C5.03999 12.54 5.87333 12.5867 6.34666 13.22L7.01999 14.12C7.55999 14.8333 8.43333 14.8333 8.97333 14.12L9.64666 13.22C10.1267 12.58 10.96 12.5333 11.5067 13.12C12.6933 14.3867 13.66 13.9667 13.66 12.1933V4.69334C13.6667 2.00668 13.04 1.33334 10.52 1.33334ZM6 4.66668C6.36666 4.66668 6.66666 4.96668 6.66666 5.33334C6.66666 5.70001 6.37333 6.00001 6 6.00001C5.62666 6.00001 5.33333 5.70001 5.33333 5.33334C5.33333 4.96668 5.62666 4.66668 6 4.66668ZM10 9.33334C9.62666 9.33334 9.33333 9.03334 9.33333 8.66668C9.33333 8.30001 9.63333 8.00001 10 8.00001C10.3667 8.00001 10.6667 8.30001 10.6667 8.66668C10.6667 9.03334 10.3733 9.33334 10 9.33334ZM10.6 5.06001L6.11333 9.54668C6.01333 9.64668 5.88666 9.69334 5.76 9.69334C5.63333 9.69334 5.50666 9.64668 5.40666 9.54668C5.21333 9.35334 5.21333 9.03334 5.40666 8.84001L9.89333 4.35334C10.0867 4.16001 10.4067 4.16001 10.6 4.35334C10.7933 4.54668 10.7933 4.86668 10.6 5.06001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptDisscount);
export default __webpack_public_path__ + "static/media/receipt-disscount.bdc60cee83cda596928d04b9ed418de3.svg";
export { ForwardRef as ReactComponent };